/**
 * Specifies the type of action to take or that was taken for a given test suite.
 * tag: 3067
 * @readonly
 * @enum {number} (int)
 */
export enum TestActionType {
  /** Start */
  Start = 0,
  /** Stop */
  Stop = 1,
  /** State */
  State = 2,
}
